import type { AppReview as AppReviewType } from 'types/capi/modules';

import StarEmpty from '~/assets/icons/StarEmpty';
import StarFull from '~/assets/icons/StarFull';
import DownloadAppBlock, {
  HOMEPAGE_APP_DOWNLOAD_URL,
  HOMEPAGE_APP_QR_CODE_URL
} from '~/components/DownloadAppBlock';

function Reviews({ items }: { items: AppReviewType[] }) {
  return (
    <div className="no-scrollbar self-stretch overflow-x-scroll">
      <div className="flex w-fit gap-2 px-4 md:gap-6 md:px-8">
        {items.map((item, index) => (
          <AppReview key={`app-review-${index}`} review={item} />
        ))}
      </div>
    </div>
  );
}

type AppReviewProps = {
  review: AppReviewType;
};

function AppReview({ review }: AppReviewProps) {
  return (
    <div className="flex size-[240px] flex-col gap-4 rounded-lg bg-black p-4 md:min-w-[264px] md:py-6">
      <div className="flex flex-col gap-2">
        <h2 className="text-sm font-semibold text-white">{review.title}</h2>
        <Rating height="16" rating={review.rating} width="16" />
      </div>
      <div className="flex">
        <p className="text-start text-sm text-white">{review.text}</p>
      </div>
    </div>
  );
}

type RatingProps = {
  height?: string;
  rating: number;
  width?: string;
};

function Rating({ rating, height = '16', width = '16' }: RatingProps) {
  const key = Math.random();
  const dimensions = { height, width };

  return (
    <div className="mt-0.5 flex items-center">
      {Array.from({ length: 5 }).map((_, i) =>
        rating >= i + 1 ? (
          <StarFull fill="#FA0" key={`star-full-${key}-${i}`} {...dimensions} />
        ) : (
          <StarEmpty
            stroke="#FA0"
            key={`star-empty-${key}-${i}`}
            {...dimensions}
          />
        )
      )}
    </div>
  );
}

export default function AppBanner({ items }: { items: AppReviewType[] }) {
  return (
    <>
      <DownloadAppBlock
        downloadLink={HOMEPAGE_APP_DOWNLOAD_URL}
        qrCode={HOMEPAGE_APP_QR_CODE_URL}
        pagePosition="Homepage App Banner"
      />
      <section className="flex flex-col gap-6 bg-dark-background py-8 lg:py-16">
        <p className="content-width text-title-lg text-start text-white lg:text-center">
          App Store reviews from our users
        </p>
        <Reviews items={items} />
      </section>
    </>
  );
}
